export function parseHttpUrl(value:string):URL|null {
  try {
    const url=new URL(value.trim());
    return url.protocol==="http:"||url.protocol==="https:"?url:null;
  } catch {
    return null;
  }
}
